import axios from "axios";

export const loadAllSellingPricesAPI = (payload) => {
  return axios
    .get(
      `${payload.dataURL}?limit=-1&requestId=${payload?.requestId}&countries=[${
        payload.countryId
      }]&transports=[${payload.transports ?? ""}]&page=1&orderBy=${
        payload.sort ? payload.sort.dir : "desc"
      }&active=${payload.activeStatus}&orderColumn=${
        payload.sort ? payload.sort.column : "id"
      }&search=${payload.search ?? ""}`,
      {
        headers: {
          Accept: "application/json",
        },
      }
    )
    .then((res) => res.data);
};

// this function not in use for now
export const loadSingleSellingPriceAPI = (payload) => {
  return axios
    .get(`/v2/sellingPrices/${payload.sellingPriceId}`, {
      headers: {
        Accept: "application/json",
      },
    })
    .then((res) => res.data);
};
